import { render, staticRenderFns } from "./AboutLinks.vue?vue&type=template&id=6de248c6&scoped=true&"
import script from "./AboutLinks.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AboutLinks.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AboutLinks.vue?vue&type=style&index=0&id=6de248c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de248c6",
  null
  
)

export default component.exports